import { useStartGame } from '../hooks/useStartGame';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
import FlexiblePageWrapper from '../components/wrapper/FlexiblePageWrapper';
import GhostWrapper from '../components/wrapper/GhostWrapper';
import NotFoundGhosts from './../components/ghosts/NotFoundGhosts';
import Header from './../components/general/Header';
import Title from './../components/text/Title';
import Subtitle from './../components/text/Subtitle';
import ButtonWrapper from '../components/wrapper/ButtonWrapper';
import Button from './../components/general/Button';
import Footer from './../components/general/Footer';

function NotFound() {
  const { t } = useLanguage();
  const { handleStartGame, gameState } = useStartGame();

  return (
    <FlexiblePageWrapper>
      <GhostWrapper>
        <br />
        <Header text={t('headerTitle')} />
        <Title size="big" text={t('notFoundTitle')} />
        <br />
        <div className="px-8 max-w-6xl">
          <Subtitle position="center" text={t('notFoundSubtitle')} />
        </div>
        <br />
        <ButtonWrapper>
          <Link to="/">
            <Button text={t('goHome')} />
          </Link>
          <Link to="/survey">
            <Button text={t('answerShortSurvey')} />
          </Link>
          {gameState?.isLoading ? (
            <div className="flex items-center justify-center gap-2 px-6 py-3 font-bold bg-yellow text-text-light rounded-2xl border-b-4 border-r-4 border-orange">
              <div className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-solid border-current border-r-transparent motion-reduce:animate-[spin_1.5s_linear_infinite]" />
              <span>{t('loading')}</span>
            </div>
          ) : (
            <Button text={t('play')} onClick={handleStartGame} />
          )}
        </ButtonWrapper>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </GhostWrapper>
      <NotFoundGhosts />
      <Footer />
    </FlexiblePageWrapper>
  );
}

export default NotFound;
